import React, { Component } from 'react';
import Spinner from '../../../../../../components/Spinner/index';
import { Tabs, Tab } from 'react-bootstrap';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ClientListPanel from './ClientListPanel';
import AddClient from '../AddClient/index';
import {
    fetchClientInformationData
} from '../../../../../../services/redux/employee/clientInformation/actions';

class ClientInformation extends Component {
    constructor(props) {
        super(props);
        this.onViewClick = this.onViewClick.bind(this);
        this.onEditClick = this.onEditClick.bind(this);
    }

    onViewClick() {
        let {
            clientInformation,
            fetchClientInformationData,
            history
        } = this.props;
        if (clientInformation.selectedItemData.clientId >= 0) {
            fetchClientInformationData(
                clientInformation.selectedItemData.clientId
            ).then(response => {
                if (response) {
                    history.push('/view-client');
                }
            });
        }
    }

    onEditClick() {
        let {
            clientInformation,
            fetchClientInformationData,
            history
        } = this.props;
        if (clientInformation.selectedItemData.clientId >= 0) {
            fetchClientInformationData(
                clientInformation.selectedItemData.clientId
            ).then(response => {
                if (response) {
                    history.push('/edit-client');
                }
            });
        }
    }

    render() {
        let { clientInformation } = this.props;
        let viewButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onViewClick}
            >
                View
            </button>
        );

        let editButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onEditClick}
            >
                Edit
            </button>
        );

        const buttonList = [viewButton, editButton];

        return (
            <div role="tabpanel" className="panel col-md-6 mb" style={{padding: 0}}>
                <Tabs defaultActiveKey={1} id="tabID">
                    <Tab eventKey={1} title="Search Clients">
                        <ClientListPanel buttons={buttonList} />
                    </Tab>
                    <Tab eventKey={2} title="Add Client">
                        <AddClient />
                    </Tab>
                </Tabs>
                {clientInformation.fetching && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    clientInformation: state.employee.clientInformation
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchClientInformationData
        },
        dispatch
    );
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ClientInformation));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/ClientInformation/screens/SearchClient/index.js